export default defineNuxtRouteMiddleware((to) => {
  // Only apply to voitures filter routes
  if (to.path.startsWith('/voitures/') && to.params.filter) {
    return navigateTo(`/voitures`, { redirectCode: 302 });
  }
});